module.exports = __webpack_public_path__ + "img/web_pr_02.3b0e67b0.png";